import React, { memo } from 'react';

import {SolicitacaoItemLista} from './SolicitacaoItemLista';
import { SolicitacaoResumida } from 'model/solicitacao/SolicitacaoResumida';
import { Paginacao } from 'view/component/Paginacao/Paginacao';
import { Tabela } from 'view/component/Tabela/Tabela';
import { Coluna } from 'view/component/Tabela/model/Coluna';
import { OrdemColunaTabela } from 'view/component/Tabela/model/OrdemColunaTabela';
import styled from 'styled-components';

import './solicitacoes-lista.css'
import { useDispatch, useSelector } from 'react-redux';
import { SolicitacoesSelector } from 'store/Solicitacoes/Solicitacoes.selector';
import { SolicitacoesAction } from 'store/Solicitacoes/Solicitacoes.action';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';


interface SolicitacoesListaProps {
  onChangeOrdem: (ordemColunaTabela: OrdemColunaTabela) => void
}

export const SolicitacoesLista: React.FC<SolicitacoesListaProps> = memo(({ onChangeOrdem}) => {
  const dispatch = useDispatch();

  const solicitacoes = useSelector(SolicitacoesSelector.lista.elementos);
  const totalSolicitacoes = useSelector(SolicitacoesSelector.lista.totalElementos);
  const isLoading = useSelector(SolicitacoesSelector.lista.carregando);
  const paginacao = useSelector(SolicitacoesSelector.lista.paginacao);
  const ordem = useSelector(SolicitacoesSelector.lista.ordem);
  const erros = useSelector(SolicitacoesSelector.lista.erros);
  
  const irParaPagina = (event: any|undefined, newPage: number) => dispatch(SolicitacoesAction.lista.carregarPagina(newPage));
  const recarregarPagina = () => irParaPagina(undefined, paginacao.atual); // FIXME: Testar para ver se precisa o +1
  const keyExtractor = (item: SolicitacaoResumida) => item.id.toString();


  const headers: Coluna[] = [
    {nome: "Prioridade", ordernavel: false, className:"sr-only"}, 
    {nome: "id", ordernavel: true, textAlign: 'center'}, 
    {nome: "Situação", ordernavel: true, atributoOrdenacao: "situacao.nome", textAlign: 'center'},
    {nome: "Classificação", ordernavel: true, atributoOrdenacao: "classificacao.nome", textAlign: 'center'},
    {nome: "Solicitante", ordernavel: false, textAlign: 'center'},
    {nome: "Título", ordernavel: true, atributoOrdenacao: "titulo"},
    {nome: "Prioridade", ordernavel: true, atributoOrdenacao: "idPrioridadeSolicitacao", textAlign: 'center'},
    {nome: "Unidade Responsável", ordernavel: true, atributoOrdenacao: "unidadeResponsavel.nome", textAlign: 'center'},
    {nome: "Responsável Técnico", ordernavel: false, textAlign: 'center'},
    {nome: "Criado Em", ordernavel: true, atributoOrdenacao: "dataCriacao", textAlign: 'center'}
  ]
  
  return <>
    <MensagensErroServidor erro={erros} />
    <EnvelopeTabela>
      <Tabela<SolicitacaoResumida>
        classNameTabela="solicitacoes-lista"
        colunas={headers}
        dados={solicitacoes}
        totalElementos={totalSolicitacoes}
        ItemTabelaComponent={SolicitacaoItemLista}
        colunaConfig={ordem}
        onChangeSort={onChangeOrdem}
        dadosKeyExtractor={keyExtractor}
        loading={isLoading}
        retry={recarregarPagina}
        />
    </EnvelopeTabela>

    <Paginacao
      paginaAtual={paginacao.atual + 1}
      paginas={paginacao.total}
      onChange={irParaPagina} />
  </>
});


const EnvelopeTabela = styled.div`
  overflow-x: scroll;
`;
